module.exports = __webpack_public_path__ + "static/ChartonHobbs-d473c1bfc414ee820ea5e7131d95e813.jpg";